import React from 'react';
import PageShell, { PageHeader, Flourish } from '../common/PageShell';
import { colors, highlight, layout, space, type } from '../../styles/tokens';

const SectionLabel = ({ children, mark = '◆' }) => (
  <p
    style={{
      ...type.subtitle,
      fontSize: '16px',
      margin: `${space[6]} 0 ${space[3]}`
    }}
  >
    {children}
    <Flourish tone={colors.sageLight}>{mark}</Flourish>
  </p>
);

const AboutPage = () => {
  const prose = { ...type.body, maxWidth: layout.prose, marginBottom: space[3] };

  return (
    <PageShell>
      <PageHeader title="About" />

      <p style={{ ...type.subtitle, fontSize: '16px', marginBottom: space[3] }}>
        My Name
        <Flourish tone={colors.sageLight}>◆</Flourish>
      </p>

      <p style={prose}>
        My name might be the first time you've heard it. If you didn't know, I was named after{' '}
        <span style={highlight}>Gaspar Yanga</span> a remarkable person who escaped slavery after
        being shipped to Mexico. Leveraging his creativity, courage, and leadership, he created a
        town in the mountains of Veracruz where escaped slaves could live freely. Yanga is
        considered one of the first freedom fighters in the Americas. A tough name to live up to...
      </p>

      <p style={prose}>
        But also inspiring. Reflecting my mixed heritage, I try to embody <em>Gaspar</em> in his
        virtues and skills every day. In this day and age I seek to do that by leveraging technology
        to create a more equitable world where tools that simplify life are available to{' '}
        <em>anyone</em> with access to a device.
      </p>

      <SectionLabel>Technical Background</SectionLabel>

      <p style={prose}>
        I am a fully self taught developer. I started learning to code in high school through online
        resources like youtube tutorials and mini projects. I later took AP Computer Science A in my
        junior year which gave me my first formal exposure to programming. Because of my self-taught
        background, some of these tools still feel foreign to me at times and I often have to look
        up syntax or documentation. But I embrace this as part of my learning process and enjoy the
        challenge of figuring things out on my own. It is the perseverance and grit in Gaspar that I
        try to channel when I hit roadblocks in my coding journey.
      </p>

      <h2 style={{ ...type.h2, margin: `${space[7]} 0 ${space[4]}` }}>
        Some Skills I've Picked Up
        <Flourish tone={colors.sageLight}>※</Flourish>
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: space[4]
        }}
      >
        {[
          { heading: 'PRODUCT', items: ['Scoping & specs', 'User interviews', 'Prototyping', 'Roadmapping'] },
          { heading: 'LANGUAGES', items: ['Python', 'TypeScript / JS', 'Swift', 'Java & SQL'] },
          { heading: 'AI', items: ['LLM APIs', 'Retrieval & evals', 'Scikit-learn', 'NumPy'] },
          { heading: 'BUILD', items: ['React / Next.js', 'SwiftUI', 'FastAPI', 'Supabase & Firebase'] }
        ].map((col) => (
          <div key={col.heading}>
            <h4 style={{ ...type.label, marginBottom: space[2] }}>{col.heading}</h4>
            <div style={{ ...type.body, fontSize: '15px', lineHeight: 2 }}>
              {col.items.map((item) => (
                <div key={item}>{item}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PageShell>
  );
};

export default AboutPage;
